import script from "./AdministratorsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdministratorsList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__